var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nlp__subscribe-box"},[_c('div',{staticClass:"nlp__subscribe-background"},[_c('NlpSubscribeBackground')],1),_c('div',{staticClass:"nlp__subscribe-wrapper"},[_c('h2',[_vm._v("Crypto News by Email")]),_c('p',[_vm._v("Subscribe to get insights and the latest crypto news.")]),_c('NlpSubscribeBar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }